import { createContext, useContext } from 'react';

const GlobalStateContext = createContext();

GlobalStateContext.displayName = 'GlobalStateContext';

const useGlobalState = () => useContext(GlobalStateContext);

export { GlobalStateContext, useGlobalState };
